import React, { useEffect, useState } from "react";
import {
  AiOutlineClose,
  AiOutlineMessage,
  AiOutlineSearch,
} from "react-icons/ai";

import { useSocket } from "../../../../Contexts/SocketContext/SocketContext";
import { useProperty } from "../../../../Contexts/PropertyContext/PropertyContext";
import { baseUrl } from "../../../../Environments/environment";
import { useAuth } from "../../../../Contexts/AuthContext/AuthContext";
import LoadingSpinner from "../../../LoadingSpinner/LoadingSpinner";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import ChatScreenModal from "../ChatScreenModal/ChatScreenModal";
import { BroadCastList } from "../BroadCastList/BroadCastList";

const ChatListModal = ({ onClose, chats }) => {
  const { selectedPropertyId } = useProperty();
  const { accessToken } = useAuth();
  const { socket } = useSocket();
  const [selectedChat, setSelectedChat] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedButton, setSelectedButton] = useState("Message");
  const [broadcastDate, setBroadcastDate] = useState(null);

  const groupMessagesByDate = (chats) => {
    if (!chats) return {};
    return chats.reduce((acc, chat) => {
      if (!chat.latestMessage[0]) return acc;
      const date = new Date(chat.latestMessage[0].createdAt).toDateString();
      if (!acc[date]) acc[date] = [];
      acc[date].push(chat);
      return acc;
    }, {});
  };

  const openChatScreen = (chat) => {
    setSelectedChat(chat);
  };

  const closeChatScreen = () => {
    setSelectedChat(null);
  };

  const handleOutsideClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
          // closeChatScreen();
    }
  };

  const filteredChats = chats?.chatLists?.filter(
    (chat) =>
      chat.guest.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      chat.guest.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (chat.guest.roomNumber &&
        (chat.guest.roomNumber.includes(searchTerm) ||
          chat.guest.roomNumber.toLowerCase().includes(searchTerm))),
  );

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-end justify-end z-[60]"
      onClick={handleOutsideClick}
    >
      <div
        className="bg-white p-0 rounded-xl rounded-t-2xl shadow-lg max-w-md w-[calc(100%-2rem)] sm:w-[30vw] sm:min-w-[350px] m-4 mb-20 lg:m-4 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-indigo-600 p-4 rounded-t-xl">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <button
                className={`flex items-center ${
                  selectedButton === "Message"
                    ? "bg-white text-indigo-600 flex gap-2"
                    : "bg-indigo-400 text-white gap-2"
                } rounded-md px-4 py-1.5 hover:bg-indigo-500 transition`}
                onClick={() => setSelectedButton("Message")}
              >
                <div>Message</div>{" "}
                {chats.totalUnreadMessages > 0 && (
                  <div className="rounded-full flex justify-center bg-yellow-400 w-4 h-4 text-gray-800 items-center text-xs">
                    {chats.totalUnreadMessages}
                  </div>
                )}
              </button>
                  {/**<button
                className={`flex items-center ${
                  selectedButton === "Broadcast"
                    ? "bg-white text-indigo-600"
                    : "bg-indigo-400 text-white"
                } rounded-md px-4 py-1.5 hover:bg-indigo-500 transition`}
                onClick={() => setSelectedButton("Broadcast")}
              >
                Broadcast
              </button>**/}
            </div>
            <button
              onClick={onClose}
              className="text-white hover:text-gray-200 focus:outline-none"
            >
              <AiOutlineClose className="h-5 w-5" />
            </button>
          </div>
 {/* Searchbar else date input */}
          <div className="mt-4">
            {selectedButton === "Broadcast" ? (
              <div className="relative">
                <input
                  type="date"
                  value={broadcastDate}
                  onChange={(e) => setBroadcastDate(e.target.value)}
                  className="w-full pl-4 px-4 py-1 border border-indigo-300 rounded-3xl focus:outline-none focus:ring-2 focus:ring-indigo-500 placeholder:text-sm text-gray-700"
                />
              </div>
            ) : (
              <div className="relative">
                <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                  <AiOutlineSearch className="text-gray-500 text-lg" />
                </span>
                <input
                  type="text"
                  placeholder="Search by room.no or name"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 px-4 py-1 border border-indigo-300 rounded-3xl focus:outline-none focus:ring-2 focus:ring-indigo-500 placeholder:text-sm"
                />
              </div>
            )}
          </div>
        </div>
{/*  ChatList */}
        <div className="">
          {selectedButton === "Message" ? (
            <div className="overflow-y-auto h-[60vh] rounded-b-xl">
              {chats?.chatLists ? (
                Object.keys(groupMessagesByDate(filteredChats)).map((date) => (
                  <div key={date}>
                    <div className="text-sm px-4 py-1 text-gray-500 bg-gray-100">
                      {date === new Date().toDateString()
                        ? "Today"
                        : date ===
                          new Date(
                            new Date().setDate(new Date().getDate() - 1),
                          ).toDateString()
                        ? "Yesterday"
                        : date}
                    </div>
                    <hr className="border-gray-200" />
                    <ul className="divide-y divide-gray-200">
                      {groupMessagesByDate(filteredChats)[date].map((chat) => (
                        <li
                          key={chat._id}
                          className="flex justify-between p-2 px-4 hover:bg-gray-50 cursor-pointer"
                          onClick={() => openChatScreen(chat)}
                        >
                          <div className="flex gap-3 items-center w-full">
                            {/* Avatar */}
                            <div className="flex-shrink-0">
                              <div className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-indigo-500 text-white">
                                {`${chat.guest.firstName[0]}${chat.guest.lastName[0]}`}
                              </div>
                            </div>

                            {/* Name + Phone */}
                            <div className="flex flex-col text-sm text-gray-900 w-full">
                              <div className="flex justify-between w-full items-center">
                                {/* Name */}
                                <div className="font-medium">
                                  {chat.guest.firstName} {chat.guest.lastName}
                                </div>

                                {/* Status Column - fixed width */}
                                <div className="flex flex-row gap-1 justify-end min-w-[120px] flex-wrap">
                                  {chat.guest.roomNumber &&
                                    chat.guest.status.currentStatus !==
                                      "Checked Out" && (
                                      <span className="text-xs text-[#065F46] bg-[#D1FAE5] rounded-full px-2 py-0.5">
                                        {chat.guest.roomNumber}
                                      </span>
                                    )}
                                  {chat.guest.roomNumber &&
                                    chat.guest.status.currentStatus ===
                                      "Checked Out" && (
                                      <span className="text-xs bg-[#e99393] text-white rounded-full px-2 py-0.5">
                                        Checked Out
                                      </span>
                                    )}
                                  {chat.guest.status.currentStatus ===
                                    "Cancelled" && (
                                    <span className="text-xs bg-[#e7e133] text-white rounded-full px-2 py-0.5">
                                      Cancelled
                                    </span>
                                  )}
                                  {!chat.guest.roomNumber &&
                                    chat.guest.status.currentStatus !==
                                      "Cancelled" && (
                                      <span className="text-xs text-[#065F46] bg-[#D1FAE5] rounded-full px-2 py-0.5">
                                        New Booking
                                      </span>
                                    )}
                                  {chat.unreadMessages > 0 && (
                                    <span className="rounded-full flex items-center justify-center text-white bg-indigo-600 w-5 h-5 text-xs">
                                      {chat.unreadMessages}
                                    </span>
                                  )}
                                </div>
                              </div>
                              {/* Phone number */}
                              <p className="text-sm text-gray-500">
                                {chat.guest.countryCode}
                                {chat.guest.phoneNumber}
                              </p>
                            </div>

                            {/* Time */}
                            <div className="text-right text-sm text-gray-500 min-w-[60px]">
                              {chat?.latestMessage[0] &&
                                new Date(
                                  chat?.latestMessage[0].createdAt,
                                ).toLocaleTimeString([], {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })}
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))
              ) : (
                <p>Loading</p>
              )}
            </div>
          ) : (
            <BroadCastList broadcastDate={broadcastDate} guests={chats} />
          )}
        </div>
      </div>
   {/* Render ChatScreenModal if a chat is selected */}
      {selectedChat && (
        <ChatScreenModal
          guestId={selectedChat.guest._id}
          guest={selectedChat.guest}
          onClose={closeChatScreen}
          closeChatModal={onClose}
        />
      )}
    </div>
  );
};

export default ChatListModal;
